import Api from '../../Base'

class PatchShelfProductsWithPOS extends Api {
  requestUrl = `/api/shelf/${this.getParams().shelfId}/pos`

  method = 'PATCH'
}

export default PatchShelfProductsWithPOS
